import { render } from "./OvApprovalModal.vue?vue&type=template&id=0e461427&scoped=true"
import script from "./OvApprovalModal.vue?vue&type=script&lang=js"
export * from "./OvApprovalModal.vue?vue&type=script&lang=js"

import "./OvApprovalModal.vue?vue&type=style&index=0&id=0e461427&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e461427"]])

export default __exports__